import React from "react";
import { useResponsiveStyles } from "../../../../styles/useResponsiveStyles";

export const ClientInfo = ({ clientData }) => {
    const { getFontSize, getSectionStyle } = useResponsiveStyles();
    return (
        <div className="ml-2">
            <h2
                className="font-semibold text-[#4C4E64]"
                style={getFontSize("identity-card-name")}
            >
                {clientData?.client_name}
            </h2>
            {clientData && (
                <p
                    className=" text-gray-600"
                    style={getFontSize("identity-card-info")}
                >
                    {clientData?.category?.category_name}-
                    {clientData?.sub_category
                        .map((subCat) => subCat.sub_category_name)
                        .join(", ")}
                    |{clientData?.tier?.tier_name}
                </p>
            )}
            <p
                className=" text-[#ED1C24]"
                style={getFontSize("identity-card-info")}
            >
                {clientData?.region}
            </p>
        </div>
    );
};
